// extracted by mini-css-extract-plugin
module.exports = {"starInstruct":"starInstruction_starInstruct__1ppRw","header":"starInstruction_header__1f4PC","title":"starInstruction_title__2GAaH"};